/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { debounceTime, map, mapTo, take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { TextBlock } from '../../classes/Elements';
import { createFont, createLineHeight, createPadding } from '../../utils';
import { IpUserInterfaceService } from '../../services/internals/user-interfaces/user-interface.service';
import { IpEmailObjectStoreService } from '../../services/internals/ip-email-object-store/ip-email-object-store.service';
import { IpUserRestApiService } from '../../services/user-rest-api-service/user-rest-api.service';
import { AbstractBlock } from '../abstract-block';
import { MatDialog } from '@angular/material/dialog';
import { CustomLinkComponent } from '../../components/custom-link/custom-link.component';

@Component({
  selector: 'ip-text-element',
  templateUrl: './text-element.component.html',
  styleUrls: ['./text-element.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextElementComponent extends AbstractBlock<TextBlock> implements OnInit, OnDestroy {
  // @Input() block: TextBlock;
  setAsReadOnly$ = this.internalService.currentEditingBlock$.pipe(map(editingBlock => editingBlock !== this.block));
  public staticQuillConfig = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ header: [1, 2, 3, 4, 5, 6, false] }, { size: ['small', false, 'large', 'huge'] }],
        [{ align: [] }, 'link'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ color: [] }, { background: [] }],
        ['clean']
      ],
      handlers: {
        placeholder(selector: string) {
          const range = this.quill.getSelection();
          const format = this.quill.getFormat();
          const text = this.quill.getText(range.index, range.length);
          this.quill.deleteText(range.index, text.length);
          this.quill.insertText(range.index, selector, format);
          // this.quill.setSelection(range.index, selector.length);
        }
      }
    }
  };
  public readonly quillInit$ = this.userRestApi.getAllUserMergeFields$.pipe(
    map(placeholder => {
      // @ts-ignore
      // this.staticQuillConfig.toolbar.container.splice(-1, 0, [{ placeholder }]);
    }),
    mapTo(true),
    take(1)
  );
  private textChanged$ = new Subject();
  private componentDestroyed$ = new Subject();

  quillEditorRef;

  constructor(
    private userRestApi: IpUserRestApiService,
    private emailObject: IpEmailObjectStoreService,
    private internalService: IpUserInterfaceService,
    private dialog: MatDialog
  ) {
    super();
  }

  getTextStyles() {
    const { color, font, lineHeight, padding } = this.block.options;

    return {
      color,
      'word-break': 'break-all',
      ...createLineHeight(lineHeight),
      ...createFont(font),
      ...createPadding(padding)
    };
  }

  contentChanged() {
    this.textChanged$.next();
  }

  getEditorInstance(editorInstance: any){
    // this.quillEditorRef = editorInstance;
    // console.log(this.quillEditorRef)
    // const toolbar = editorInstance.getModule('toolbar');
    // toolbar.addHandler('link', this.linkHandler);
  }


  linkHandler = (link, callback) => {
    const range = this.quillEditorRef.getSelection();
    console.log("range == ",range);
    console.log("log link == ",link);
    this.customLinkPopup();
    // this.quillEditorRef.clipboard.dangerouslyPasteHTML(range.index, img);
  }

  customLinkPopup(){
    let dialogRef = this.dialog.open(CustomLinkComponent, {
      height: '400px',
      width: '600px',
    });
  }

  ngOnInit() {
    this.textChanged$.pipe(debounceTime(600), takeUntil(this.componentDestroyed$)).subscribe(() => {
      this.emailObject.markForCheck();
    });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
    this.componentDestroyed$.complete();
  }
}
